import Locale from 'locale2'
import { arrayFirst } from './array'

export const defaultLanguage = 'en'

export const supportedLanguages = [
  'ca',
  'en',
  'es',
  'fr',
  'it',
  'pt',
]

export function isLanguageSupported (language) {
  return supportedLanguages.includes(language)
}

/**
 * Returns locale code, like the one used in html lang attribute.
 *
 * @return String with locale code in "code-country" format. If the country
 * isn't supported, returns "code", or default language if code isn't supported
 * either.
 * @example "en"
 * @example "fr"
 * @example "en-US"
 * @example "es-ES"
 */
export function lang () {
  const withCountry = Locale.replace(/[^A-Za-z]+/g, '-').replace('/^-|-$/g', '')
  const noCountry = arrayFirst(withCountry.match(/^[a-z]+/g))

  if (isLanguageSupported(withCountry)) {
    return withCountry
  } else if (isLanguageSupported(noCountry)) {
    return noCountry
  } else {
    return defaultLanguage
  }
}

/**
 * Returns simplified language code, usually only two letters. If the code isn't
 * supported, returns default language code.
 *
 * @return String with locale code, always without country.
 * @example "pt"
 * @example "fr"
 */
export function language () {
  return arrayFirst(lang().match(/^[a-z]+/g))
}

/**
 * Returns locale code, but using "_" instead of "-".
 *
 * @return String with locale code in "code_country" format. If the country
 * isn't supported, returns "code", or default language if code isn't
 * supported either.
 * @example "en"
 * @example "it"
 * @example "en_US"
 * @example "es_ES"
 */
export function locale () {
  return lang().replace('-', '_')
}

export default {
  defaultLanguage,
  isLanguageSupported,
  lang,
  language,
  locale,
  supportedLanguages,
}



// WEBPACK FOOTER //
// ./src/server/helpers/language.js